import { Model } from "@vuex-orm/core";
import { CommonHelper } from "../../helper/common-helper";

export interface ticketStatusEntity {
  id: number;
  name: string;
}

export class ticketStatusEntity extends Model {
  static entity = "ticketStatusEntity";
  static primaryKey = "id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }

  get sortOrder() {
    return CommonHelper.getTicketStatusSortOrder(this.id);
  }
}

export interface ticketPriorityEntity {
  id: number;
  name: string;
}

export class ticketPriorityEntity extends Model {
  static entity = "ticketPriorityEntity";
  static primaryKey = "id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface ticketSeverityEntity {
  id: number;
  name: string;
}

export class ticketSeverityEntity extends Model {
  static entity = "ticketSeverityEntity";
  static primaryKey = "id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface clientStatusEntity {
  id: number;
  name: string;
}

export class clientStatusEntity extends Model {
  static entity = "clientStatusEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface contactStatusEntity {
  id: number;
  name: string;
}

export class contactStatusEntity extends Model {
  static entity = "contactStatusEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface ticketSourceEntity {
  id: number;
  name: string;
}

export class ticketSourceEntity extends Model {
  static entity = "ticketSourceEntity ";
  static primaryKey = "id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface ticketTypeEntity {
  ticketTypeId: number;
  name: string;
  description: string;
  serviceProviderId: number;
  isActive: boolean;
}

export class ticketTypeEntity extends Model {
  static entity = "ticketTypeEntity";
  static primaryKey = "ticketTypeId";
  static fields() {
    return {
      ticketTypeId: this.attr(null),
      name: this.string(null),
      description: this.string(null),
      serviceProviderId: this.number(0),
      isActive: this.boolean(true),
    };
  }

  static beforeSelect(records: ticketTypeEntity[]) {
    return records.filter((row: ticketTypeEntity) => row.ticketTypeId != 0);
  }
}

export interface ticketLocationEntity {
  id: number;
  name: string;
}

export class ticketLocationEntity extends Model {
  static entity = "ticketLocationEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface clientWebDoaminStatusEntity {
  id: number;
  name: string;
}

export class clientWebDoaminStatusEntity extends Model {
  static entity = "clientWebDoaminStatusEntity";
  static primaryKey = "id";
  static fields() {
    return {
      id: this.number(0),
      name: this.string(""),
    };
  }
}

export interface assetTypeEntity {
  id: number;
  name: string;
}

export class assetTypeEntity extends Model {
  static entity = "assetTypeEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface assetStatusEntity {
  id: number;
  name: string;
}

export class assetStatusEntity extends Model {
  static entity = "assetStatusEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface requisitionStatusEntity {
  id: number;
  name: string;
}

export class requisitionStatusEntity extends Model {
  static entity = "requisitionStatusEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface purchaseOrderStatusEntity {
  id: number;
  name: string;
}

export class purchaseOrderStatusEntity extends Model {
  static entity = "poNumberStatusEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface eventEntity {
  integrationEventId: number;
  eventName: string;
}

export class eventEntity extends Model {
  static entity = "eventEntity";
  static primaryKey = "integrationEventId";
  static fields() {
    return {
      integrationEventId: this.attr(null),
      eventName: this.string(null),
    };
  }
}

export interface checkTypeEntity {
  id: number;
  name: string;
}

export class checkTypeEntity extends Model {
  static entity = "checkTypeEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface checkRegionEntity {
  id: number;
  name: string;
}

export class checkRegionEntity extends Model {
  static entity = "checkRegionEntity";
  static primaryKey = "id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}

export interface invoiceStatusEntity {
  id: number;
  name: string;
}

export class invoiceStatusEntity extends Model {
  static entity = "invoiceStatusEntity";
  static primaryKey = "Id";
  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
    };
  }
}
